__turbopack_context__.v({
  "cardImage": "Hami7q_cardImage",
  "hiddenOnMobile": "Hami7q_hiddenOnMobile",
});
